import { IStatus } from "@/fe-core/meta/interfaces/root";
import { RootState } from "@/fe-core/meta/types/root";
import {
  depositPaymentMethodTypes,
  ProcessDepositState,
} from "@/fe-core/meta/types/user/cashier/processDeposit";
import { cashierSelector } from ".";

export const processDepositSelector = (
  state: RootState
): ProcessDepositState => {
  const { processDeposit } = cashierSelector(state);

  return processDeposit;
};

export const paymentMethodSelector = (
  state: RootState
): depositPaymentMethodTypes | null => {
  const { paymentMethod } = processDepositSelector(state);

  return paymentMethod;
};

export const processDepositPendingSelector = (state: RootState): boolean => {
  const { pending } = processDepositSelector(state);

  return pending;
};

export const processDepositStatusSelector = (
  state: RootState
): IStatus | string | null => {
  const { status } = processDepositSelector(state);

  return status;
};

export const processDepositRedirectSelector = (
  state: RootState
): {
  continueUrl: string | null;
  accessToken: string | null;
  token: string | null;
  authToken: string | null;
} => {
  const { continueUrl, accessToken, token, authToken } =
    processDepositSelector(state);

  return {
    continueUrl: continueUrl || null,
    accessToken: accessToken || null,
    token: token || null,
    authToken: authToken || null,
  };
};
